(function() {
    angular.module('tmx-app').controller('sessionHistoryReportCtrl', ['resolvedData',
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'UsersService',
        'SessionHistoryReportService',

        function SessionHistoryReportCtrl(resolvedData,
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            UsersService,
            SessionHistoryReportService
        ) {
            var SessionHistoryReportVM = this;
            SessionHistoryReportVM.menu = menu;
            SessionHistoryReportVM.gridData = new kendo.data.ObservableArray([]);
            var todayDate = new Date();
            SessionHistoryReportVM.search = search;
            SessionHistoryReportVM.filterEnabled = false;
    // SessionHistoryReportVM.disableExport = true;
            SessionHistoryReportVM.toggle = toggle;
            SessionHistoryReportVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportBranchId = null;
            var exportUserId = null;
            var exportNationalId=null;
            var exportFromDate=null;
            var exportToDate=null;
            SessionHistoryReportVM.activeRoles = [];
            SessionHistoryReportVM.userList = [];
            SessionHistoryReportVM.UserId = null;
            SessionHistoryReportVM.clear = clear;
            SessionHistoryReportVM.RoleId = null;
            SessionHistoryReportVM.formatColumnName = tmxUtility.formatColumnName;
            (function InitializePage() {
                if (tmxUtility.exists(resolvedData.Roles.data)) {
                    var activeRoles = resolvedData.Roles.data.filter(role =>
                        new Date(role.EffectiveStartDate) < todayDate < new Date(role.EffectiveEndDate)
                    );
                }
                SessionHistoryReportVM.activeRoles = activeRoles.map(x => ({ LookupId: x.RoleId, VisibleValue: x.RoleName }));
            })();
            SessionHistoryReportVM.OnRoleSelected = function (selectedRole) {
                SessionHistoryReportVM.userList = [];
                SessionHistoryReportVM.UserId = null;
                SessionHistoryReportVM.RoleId = selectedRole;
                if (!tmxUtility.exists(selectedRole)) return;
                UsersService.getUserByRole(selectedRole).then(function (response) {
                    if (tmxUtility.exists(response, 'data')) {
                        SessionHistoryReportVM.userList = response.data.map(x => ({ LookupId: x.UserID, VisibleValue: x.UserName }));
                    }
                });

            }
            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
    //   SessionHistoryReportVM.disableExport = true;
                SessionHistoryReportVM.UserId = null;
                SessionHistoryReportVM.Role=null;
                SessionHistoryReportVM.RoleId=null;
                SessionHistoryReportVM.FromDate=null;
                SessionHistoryReportVM.ToDate=null;
                SessionHistoryReportVM.container.SessionHistoryReportGrid.dataSource.read();
            }

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId=obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            SessionHistoryReportVM.exportToPdf = exportToPdf;

            function search() {
                SessionHistoryReportVM.container.SessionHistoryReportGrid.dataSource.read();
                SessionHistoryReportVM.filterEnabled = true;
                exportUserId=angular.copy(SessionHistoryReportVM.UserId);
                exportBranchId=angular.copy(SessionHistoryReportVM.RoleId);
                exportFromDate = moment(new Date(SessionHistoryReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(SessionHistoryReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
            }

            function exportToPdf() {
                var loanapplicationnumber = exportLoanApplicationNumber
                    ? exportLoanApplicationNumber
                    : null;
                var branchid = exportBranchId
                    ? exportBranchId
                    : null;
                var nationalid = exportNationalId
                    ? exportNationalId
                    : null;
                var offset= -1 * (new Date().getTimezoneOffset());
                var fromdate = exportFromDate
                    ? exportFromDate
                    : null;
                var todate = exportToDate
                    ? exportToDate
                    : null;
                SessionHistoryReportService.exportSessionHistoryReport(loanapplicationnumber,branchid,nationalid,offset,fromdate,todate);
            }

            SessionHistoryReportVM.formatDateTime = function(item){
                if(item){
                    var d = new Date(item);
                    var str = (d.getDate() +"/"+ (d.getMonth()+1) +"/"+ d.getFullYear()).concat(";");


                    var hours = d.getHours();
                    var minutes = d.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0'+minutes : minutes;
                    str += " "+ hours + ':' + minutes + ' ' + ampm;

                    str = str.split(";");
                    return str[0] + str[1];
                }
                else
                    return "N/A";
            }
            SessionHistoryReportVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {

                            var offset=null;
                            var fromdate='';
                            var todate='';
                            var RoleId = null;
                            var UserId = null;
                            offset= -1 * (new Date().getTimezoneOffset());

                            if (SessionHistoryReportVM.FromDate) {
                                fromdate = moment(new Date(SessionHistoryReportVM.FromDate)).startOf('day').toISOString().replace("Z", "");                            
                            }
            // .replace(/:/g, '~')
                            if (SessionHistoryReportVM.ToDate) {
                                todate = moment(new Date(SessionHistoryReportVM.ToDate)).endOf('day').toISOString().replace("Z", "");                            
                            }
                            if (
                                angular.isUndefined(SessionHistoryReportVM.RoleId) ||
                                (SessionHistoryReportVM.RoleId == "")) {
                                    RoleId = 0;
                            } 
                            else {
                                RoleId = SessionHistoryReportVM.RoleId
                                    ? SessionHistoryReportVM.RoleId
                                    : null;
                            }
                            if (
                                angular.isUndefined(SessionHistoryReportVM.UserId) ||
                                (SessionHistoryReportVM.UserId == "")) {
                                    UserId = 0;
                            } 
                            else {
                                UserId = SessionHistoryReportVM.UserId
                                    ? SessionHistoryReportVM.UserId
                                    : null;
                            }
                            var objArgs = {
                                "FromDate":fromdate,
                                "ToDate":todate,
                                "RoleId":RoleId,
                                "UserId":UserId
                            };
              
                            var filters = {
                                "StoredProcedure": "sp_session_history_report",
                                "Arguments": objArgs,
                                "ReportName": "Session_History_Report"
                            };

                            SessionHistoryReportVM.o = angular.copy(o);
                            SessionHistoryReportVM.filters = SessionHistoryReportVM.o.data.filter;
                            firebase.logTmxEvent('report',{name:'Session History Report'});
                            SessionHistoryReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {
              
                                if (response) {
                                    SessionHistoryReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
  
                            SessionHistoryReportVM.filterEnabled = true;
            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
          // parse: function(response) {
          //   if (response != undefined) {
          //     response = response.data;

          //     var invoices = [];
          //     var invoiceNumber = [];

          //     for (var i = 0; i < response.length; i++) {
          //       var invoice = response[i];

          //       invoice.InvoiceGroup =
          //         invoice.InvoiceGroup +
          //         " -- Date:" +
          //         moment(invoice.InvoiceDate).format("DD/MM/YYYY") +
          //         " -- Customer: " +
          //         invoice.CustomerName +
          //         " -- Status: " +
          //         invoice.ClubbedStatus;
          //       invoice.InvoiceDate = moment(invoice.InvoiceDate).format(
          //         "DD-MM-YYYY"
          //       );

          //       if (!invoiceNumber.includes(invoice.InvoiceNumber)) {
          //         invoices.push(invoice);
          //         invoiceNumber.push(invoice.InvoiceNumber);
          //       }
          //     }


          //     invoices = {
          //       data: invoices
          //     };

          //     return invoices;
          //   }
          // }
                    },
        // aggregate: [
        //   { field: "InvoiceNumber", aggregate: "count" },
        //   { field: "InvoiceLineTax", aggregate: "count" },
        //   { field: "InvoiceTotalAmount", aggregate: "sum" }
        // ],
        // group: {
        //   field: "InvoiceNumber",
        //   aggregates: [
        //     { field: "InvoiceNumber", aggregate: "count" },
        //     { field: "InvoiceLineTax", aggregate: "count" },
        //     { field: "InvoiceTotalAmount", aggregate: "sum" }
        //   ]
        // },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
        // sort: [{ field: "InvoiceDate", dir: "desc" }]
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "SessionHistoryReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
          // console.log(row.cells[8].value);
                        row.cells[8].value = SessionHistoryReportVM.formatDateTime(row.cells[8].value);
                        row.cells[7].value = SessionHistoryReportVM.formatDateTime(row.cells[7].value);
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: SessionHistoryReportService.GridColumns
            };
        }]);
})();
